import { render, staticRenderFns } from "./maxStudentsSettings.vue?vue&type=template&id=ac996a1e&scoped=true&"
import script from "./maxStudentsSettings.vue?vue&type=script&lang=js&"
export * from "./maxStudentsSettings.vue?vue&type=script&lang=js&"
import style0 from "./maxStudentsSettings.vue?vue&type=style&index=0&id=ac996a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac996a1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
